var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGreybg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VT_University",
    "data-name": "VT University",
    transform: "translate(-781 -162.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8067",
    "data-name": "Rectangle 8067",
    width: 52,
    height: 52,
    transform: "translate(781 162.549)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-graduation_cap",
    transform: "translate(792 172.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30590",
    "data-name": "Path 30590",
    d: "M15.472,3.12,15,4v7H29l.462-.886Zm-.944,0L15,4v7H1l-.462-.886Zm0,15.76L15,18V11H1l-.462.886Zm.944,0L15,18V11H29l.462.886Z",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30591",
    "data-name": "Path 30591",
    d: "M29,10a1,1,0,1,0,1,1A1,1,0,0,0,29,10ZM1,10a1,1,0,1,0,1,1,1,1,0,0,0-1-1Zm14,7a1,1,0,1,0,1,1A1,1,0,0,0,15,17ZM15,3a1,1,0,1,0,1,1A1,1,0,0,0,15,3Z",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30592",
    "data-name": "Path 30592",
    d: "M16.366,20.669a1.993,1.993,0,0,1-.255.106,2.851,2.851,0,0,1-2.218,0,1.92,1.92,0,0,1-.259-.108L6,16.852V21c0,2.761,4.029,5,9,5s9-2.239,9-5V16.852ZM27,15.353V26a1,1,0,0,0,2,0V14.353Z",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30593",
    "data-name": "Path 30593",
    d: "M30,26c0,1.1-2,4-2,4s-2-2.9-2-4a2,2,0,0,1,4,0Z",
    fill: "#533ffb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGreybg);
export default __webpack_public_path__ + "static/media/university-greybg.b14378a979d384b6999ff758142323bb.svg";
export { ForwardRef as ReactComponent };